import { render, staticRenderFns } from "./ButtonPress.vue?vue&type=template&id=09aa490f&scoped=true"
import script from "./ButtonPress.vue?vue&type=script&lang=js"
export * from "./ButtonPress.vue?vue&type=script&lang=js"
import style0 from "./ButtonPress.vue?vue&type=style&index=0&id=09aa490f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aa490f",
  null
  
)

export default component.exports